/**
 * toggleDropdown creates the on click listener for '.js-toggle-dropdown' and '.dropdown .dropdown-content'.
 *
 * The on click listener for '.js-toggle-dropdown' toggles the class 'is-active' on the given element.
 * The '.js-toggle-dropdown' element requires:
 * - data-toggle-dropdown-id: String    (Id of element to toggle the class on, ie 'element')
 *
 * The on click listener for '.dropdown .dropdown-content' toggles the class 'is-active' on itself.
 *
 * The on click listener for document remoces the class 'is-active' from itself.
 */

function toggleDropdown() {
	$(document).on('click', '.js-toggle-dropdown', function() {
		const $this = $(this);
		const id = $this.data('toggle-dropdown-id');
		const $target = $(`#${id}`);

		/* Don't cont if has disabled */
		if ($(`#${id} [disabled]`).length > 0) {
			return;
		}

		/* If the dropdown is about to open, set the visibility hidden so we can calculate whether it should drop up or drop down */
		const $content = $target.find('.dropdown-content').first();
		if (!targetIsActive) {
			$content.css('visibility', 'hidden');
		}

		/* Toggle the active class */
		const targetIsActive = $target.hasClass('is-active');
		$('.dropdown.is-active').removeClass('is-active');

		/* If the dropdown is about to open, open it, and start calculating whether it should drop up or drop down */
		if (!targetIsActive) {
			$target.addClass('is-active');

			/* Calculate whether there is enough space for the dropdown */
			const dropdownDropsUp = $target.hasClass('is-up');

			const top = $target.find('.dropdown-content')[0].getBoundingClientRect().top;

			const bottom = $target.find('.dropdown-content')[0].getBoundingClientRect().bottom;

			const windowHeight = window.innerHeight;

			const hasEnoughSpaceToDropUp = top >= 0;

			const hasEnoughSpaceToDropDown = windowHeight >= bottom;

			if (!hasEnoughSpaceToDropUp && dropdownDropsUp) {
				// make the dropdown drop down
				$target.removeClass('is-up');
			} else if (!hasEnoughSpaceToDropDown && !dropdownDropsUp) {
				// make the dropdown drop up
				$target.addClass('is-up');
			}

			/* Turn visibility back on */
			$content.css('visibility', '');
		}
	});

	$(document).on('click', '.dropdown .dropdown-content', function() {
		if (
			$(this)
				.closest('.dropdown')
				.hasClass('is-active')
		) {
			$(this)
				.closest('.dropdown')
				.removeClass('is-active');
		}
	});

	$(document).on('click', e => {
		if ($('.dropdown.is-active').length == 0) {
			return;
		}
		if ($(e.target).closest('.dropdown.is-active').length == 0) {
			$('.dropdown.is-active').removeClass('is-active');
		}
	});
}
toggleDropdown();
